import type { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../lib/auth';
import { homePath } from '../lib/home';
import type { PermissionKey } from '../types';

// Route-level gate for permission-restricted pages. Sits inside RequireAuth, so
// a session and an operator profile are already guaranteed here.
//
// This is not the security boundary — it stops bookmarks and typed URLs from
// landing on a page whose data the server will refuse anyway. The real check is
// operations.fn_assert_permission() inside the RPCs those pages call.
//
// A refused route bounces to the account's own home (see lib/home.ts), so an
// external partner login never gets sent to the calendar.
export function RequirePermission({
  permission,
  children,
}: {
  permission: PermissionKey;
  children: ReactNode;
}) {
  const { can } = useAuth();
  if (!can(permission)) return <Navigate to={homePath(can)} replace />;
  return <>{children}</>;
}
